import ViewState from "../views/ViewState";
const queryTitle = (view, queryId) => view && view.search && view.search.queries ? view.search.queries.keySeq().map((q, idx) => {
  if (queryId !== void 0 && q.id !== void 0 && queryId === q.id) {
    return view.state ? view.state.getIn([q.id], ViewState.create()).titles.getIn(["tab", "title"], `Page#${idx + 1}`) : `Page#${idx + 1}`;
  }
  return void 0;
}).filter((title) => title !== void 0).first() : void 0;
export default queryTitle;
